import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { colors, Button, TextButton, PlusIcon, BodyLargeBold, Pill } from 'prospect-path-base'
import { Activity, Section, SectionHeader, Empty, EmptyDetail, Product } from 'prospect-path-components'
import styled from 'styled-components';
import Moment from 'moment-timezone';

const ActivityLink = styled.a`
  text-decoration: none;
`

const capitaliseString = (str) => {
    return str[0].toUpperCase() + str.substring(1);
}

const ActivitySection = ({ activities, ...props }) => (
  <Section {...props}>
    {activities.length === 0 && (
      <Empty
        footerImage={
          <svg width="100%" height="120" viewBox="0 0 550 144" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs />
            <rect y="14" width="56" height="20" rx="10" fill="#EAEAEA" />
            <rect x="80" y="14" width="336" height="20" rx="10" fill="#BBB" />
            <rect x="507" y="14" width="43" height="20" rx="10" fill="#EAEAEA" />
            <g opacity=".5">
              <rect y="62" width="56" height="20" rx="10" fill="#EAEAEA" />
              <rect x="80" y="62" width="336" height="20" rx="10" fill="#BBB" />
              <rect x="507" y="62" width="43" height="20" rx="10" fill="#EAEAEA" />
            </g>
            <g opacity=".2">
              <rect y="110" width="56" height="20" rx="10" fill="#EAEAEA" />
              <rect x="80" y="110" width="336" height="20" rx="10" fill="#BBB" />
              <rect x="507" y="110" width="43" height="20" rx="10" fill="#EAEAEA" />
            </g>
          </svg>
        }
      >
        <EmptyDetail
          title="You must be new here"
          subtitle="You can track your activity here, once you and your team start using your accounts"
        />
      </Empty>
    )}

    {activities.length > 0 && (
      <Fragment>
        <SectionHeader
          title={(
            <BodyLargeBold style={{ marginBottom: '1rem' }}>Activity</BodyLargeBold>
          )}
        />

        {activities.map(activity => (
            <ActivityLink href={activity.activity_subject_link} >
                <Activity
                    key={activity.id}
                    time={Moment.tz(activity.created_at, 'UTC').local().startOf('minutes').fromNow()}
                    summary={activity.text}
                    tag={activity.type.reference ? <Pill>{capitaliseString(activity.type.reference)}</Pill> : null}
                />
            </ActivityLink>

        ))}
      </Fragment>
    )}
  </Section>
)

ActivitySection.defaultProps = {
  activities: [],
}

ActivitySection.propTypes = {
  activities: PropTypes.array,
}

export default ActivitySection
